<script>
export default {
    name: 'empty-content',

    props: {
        icon: {
            type: String,
            default: null
        },

        title: {
            type: String,
            default: null
        }
    },

    computed: {
        iconClass() {
            return [`fa fa-${this.icon}`];
        }
    }
}
</script>

<template>
    <div class="panel-empty text-center">
        <div class="panel-empty__icon" v-if="icon || $slots.icon">
            <slot name="icon">
                <i :class="iconClass"></i>
            </slot>
        </div>

        <h4 class="panel-empty__title" v-if="title">
            {{title}}
        </h4>

        <div class="panel-empty__info">
            <slot></slot>
        </div>
    </div>
</template>